<section class="grid-container">
    <div class="grid-content section-content placement-center">
        <ul class="grid-list images-list">
            <li class="grid-list-item" *ngFor="let category of mediaCategories">
              <a class="link-img" [routerLink]="['/media-library', category.id]">
                <img *ngIf="category.hasPreview" [src]="category.previewUrl" alt="Геоінформаційна система">
                <img *ngIf="!category.hasPreview" src="../../../assets/images/landscape.svg" alt="Геоінформаційна система">
                <span class="body-lg text-shadow">{{ category.name }}</span>
              </a>
            </li>
        </ul>
    </div>
</section>
